import React from 'react';
import { Card } from 'antd';
import type { CardProps } from 'antd';
import { useTheme } from '@shared/providers/theme/ThemeContext';

export interface AppCardProps extends Omit<CardProps, 'headStyle'> {
  /** When true, header uses theme colors (primary + sectionHeaderText) like CollapsibleCard */
  isHeaderColor?: boolean;
}

const AppCard = React.forwardRef<HTMLDivElement, AppCardProps>((props, ref) => {
  const { isHeaderColor, styles, ...rest } = props;
  const { colors } = useTheme();

  const existingHeader =
    styles && typeof styles === 'object' && 'header' in styles
      ? (styles as { header?: React.CSSProperties }).header
      : undefined;

  const headerStyle: React.CSSProperties | undefined = isHeaderColor
    ? {
        ...existingHeader,
        backgroundColor: colors.primary,
        color: colors.sectionHeaderText,
      }
    : existingHeader;

  const mergedStyles: AppCardProps['styles'] = {
    ...(styles && typeof styles === 'object' ? (styles as object) : {}),
    ...(headerStyle != null ? { header: headerStyle } : {}),
  };

  const restForCard = { ...rest };
  if ('headStyle' in restForCard) {
    delete (restForCard as Record<string, unknown>).headStyle;
  }
  return <Card ref={ref} styles={mergedStyles} {...restForCard} />;
});

AppCard.displayName = 'AppCard';

export default AppCard;
